"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#005271"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.14,12.35a2.65,2.65,0,0,1,4.52,1.87,2.68,2.68,0,0,1-.77,1.87l-2.43,2.42,2.13,2.13c1.83-2.91,6.18-10.13,6.18-13.28a7.36,7.36,0,1,0-14.72,0c0,1.7,1.27,4.6,2.73,7.35Zm2.27-8.21a3.22,3.22,0,1,1-3.22,3.22A3.23,3.23,0,0,1,13.41,4.14Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.41,18.51l3.45-3.45a1.2,1.2,0,1,0-1.69-1.69L8.72,16.82,5.27,13.37a1.2,1.2,0,1,0-1.69,1.69L7,18.51,3.58,22a1.19,1.19,0,0,0,0,1.69,1.2,1.2,0,0,0,1.69,0L8.72,20.2l3.45,3.45a1.2,1.2,0,0,0,1.69,0,1.19,1.19,0,0,0,0-1.69Z"
  })));
};

exports["default"] = _default;